// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'

/** Why the SSO requirement switched back off: the company has no SSO provider connected. */
export function SsoUnavailableHint() {
  const { t } = useTranslation('settings')
  return <span className="d-block text-danger mt-1" role="alert">{t('signInRequirements.noTenant')}</span>
}
